export const ROOT_PATH = 'http://cmcti.parnamirim.rn.gov.br/rest';
// export const ROOT_PATH = 'http://172.16.0.64/portal_cmcti/rest';

export const API_PATH = `${ROOT_PATH}`;



// WEBPACK FOOTER //
// ./src/app/util/constants.ts